import React, { useEffect, useContext } from 'react';
import { ThemeContext } from '../../ThemeContext';
import Proba from '../../components/Proba';
import HeroSection from './HeroSection/HeroSection';
import './Home.scss';
import FeaturesShowcase from './FeatureShowcase';
import HowItWorks from './HowItWorks';
import HubPreview from './HubPreview';

const Home = () => {
  const { theme } = useContext(ThemeContext);
  const isDarkTheme = theme === 'dark';
  console.log('Home');

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;

      const sections = document.querySelectorAll('.feature-container');

      sections.forEach((section, index) => {
        const sectionTop = index * windowHeight;
        const sectionBottom = (index + 1) * windowHeight;

        if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
          section.classList.add('active');
        } else {
          section.classList.remove('active');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  console.log('Rendering Home component with theme:', theme);

  return (
    <div
      className={`home-page position-relative ${isDarkTheme ? 'theme-dark' : 'theme-light'}`}
    >
      {/* Content */}
      <div className="position-relative" style={{ zIndex: 3 }}>
        <div className="features-container bg-transparent text snap-page">
          {/* Hero Section - Full viewport height */}
          <div className="d-flex align-items-center justify-content-center">
            <HeroSection />
          </div>

          <FeaturesShowcase />
          {/* <HowItWorks />*/}
          <HubPreview />

          <div className="snap-section d-flex flex-column">
            <Proba />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
